// OUTDirectoryParser.tsx
import * as React from "react";
import "./index.css"
import { parseInfo } from "./swmmjs_module";

const OUTDirectoryParser = ({outbin, onChange}: any) => {
  React.useEffect(() => {
    let outdir = parseInfo(outbin)
    onChange({name: 'outdir', value: outdir})
  }, [outbin])

  return(
    <></>
  )
};
 
export {OUTDirectoryParser};